import React, { useRef, useEffect, useState } from "react"
import ReactTable from "react-table"
import numeral from "numeral"
import settings from "settings"
import _ from "lodash"
import FullTable from "components/FullTable"
import ImageExport from "components/ImageExport"
import ExcelOnly from "components/ExcelOnly"
import lotTypes from "widgets/salesByLotTypePie"
const WeeklyMap = React.lazy(() => import("components/WeeklyMap"))

function DefaultLayout(props) {
	const [redraw, setRedraw] = useState(0)
	const [mappingLots, setMappingLots] = useState(null)
	let mappingEnabled = _.get(settings, `weekly.mapping`)

	useEffect(() => {
		try {
			if (mappingEnabled && props.props.props.payload.weeklyMapping) {
				buildMappingLots()
			}
		} catch (e) {
			console.log(e)
		}
	}, [props.props.props.payloadStatus])

	const buildMappingLots = () => {
		if (mappingEnabled) {
			let lots = props.props.props.payload.weeklyMapping
			if (lots) setMappingLots(props.props.props.payload.weeklyMapping)
		}
	}

	const notify = () => {
		setRedraw(_.random(1, 9999))
	}

	const monthlyAverageOutput = (type) => {
		try {
			if (!settings?.enabled?.quickMonthlyAverages) {
				return ""
			}
			let value = props.props.props.payload.exec.monthlyAverages[type]
			return (
				<div
					className="absolute bottom-0 left-0 w-full bg-white text-blue text-xs text-center quickStats__whiteBox"
					title="Monthly average since inception">
					<span>Monthly Avg: {value}</span>
				</div>
			)
		} catch (e) {
			console.log(e)
			return ""
		}
	}

	return (
		<div className="body__stage" id="stage">
			<div className="imageGroup">
				{props.props.type == "island" ? props.islandTitle() : props.internalTitle()}
				{props.props.state.weekly_message && (
					<div className="weeklyMessage content">
						<h4 className="font-bold py-4">Current Weekly Message</h4>
						<div
							dangerouslySetInnerHTML={{
								__html: props.props.state.weekly_message,
							}}></div>
					</div>
				)}
				<div className="quickStats">
					<ul className="quickStats__list">
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{props.props.state.weeklyTotals.gross.toLocaleString()}
								</div>
								<div className="quickStats__type">Gross Sales</div>
							</div>
							{monthlyAverageOutput("gross")}
						</li>
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{props.props.state.weeklyTotals.net.toLocaleString()}
								</div>
								<div className="quickStats__type">Net Sales</div>
							</div>
							{monthlyAverageOutput("net")}
						</li>
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{props.props.state.weeklyTotals.busts.toLocaleString()}
								</div>
								<div className="quickStats__type">Cancellations</div>
							</div>
							{monthlyAverageOutput("cancels")}
						</li>
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{props.props.state.weeklyTotals.closings.toLocaleString()}
								</div>
								<div className="quickStats__type">Closings</div>
							</div>
							{monthlyAverageOutput("closings")}
						</li>
						<li className="quickStats__item">
							<div>
								<div className="quickStats__stat">
									{props.props.state.weeklyTotals.starts.toLocaleString()}
								</div>
								<div className="quickStats__type">Starts</div>
							</div>
							{monthlyAverageOutput("starts")}
						</li>
						{_.get(settings, "weekly.splitTraffic") ? (
							<>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{props.props.state.weeklyTotals.builderTraffic.toLocaleString()}
										</div>
										<div className="quickStats__type">Builder Traffic</div>
									</div>
								</li>
								<li className="quickStats__item">
									<div>
										<div className="quickStats__stat">
											{props.props.state.weeklyTotals.welcomeTraffic.toLocaleString()}
										</div>
										<div className="quickStats__type">Welcome Traffic</div>
									</div>
								</li>
							</>
						) : (
							<li className="quickStats__item">
								<div>
									<div className="quickStats__stat">
										{props.props.state.weeklyTotals.traffic.toLocaleString()}
									</div>
									<div className="quickStats__type">Traffic</div>
								</div>
								{monthlyAverageOutput("traffic")}
							</li>
						)}
					</ul>
				</div>
				{_.get(settings, `weekly.mapping`) && (
					<WeeklyMap
						property={props?.props?.state?.property}
						lots={mappingLots}
						payload={props.props.state}
						notify={notify}
					/>
				)}
				<div className="statBox">
					<div className="statBox__row statBox__row--triple">
						<div className="statBox__box">
							<h3 className="statBox__title" style={{ marginBottom: 3 }}>
								Realtor Sales
							</h3>
							{props.props.methods.realtorPercent(props.props.state, props.props.props)}
						</div>
						<div className="statBox__box">
							<h3 className="statBox__title">Cancellation Rate</h3>
							{props.props.methods.bustRate(props.props.state, props.props.props)}
						</div>
						<div className="statBox__box">
							<h3 className="statBox__title">Sales Dirt vs Spec</h3>
							{props.props.methods.dirtVsSpec(props.props.state, props.props.props)}
							<p className="small">
								Spec vs Dirt Sale Summary evaluates the gross sales for the week, only taking into
								account cancellations if the contract was both written and canceled in the reporting
								week
							</p>
						</div>
					</div>
					{_.get(props.props.state, `user.group`) == 1 || !_.get(settings, `weekly.restrictSalesMeter`) ? (
						<>{props.props.methods.salesMeter(props.props.state, props.props.props, props.props.type)}</>
					) : (
						""
					)}
				</div>
			</div>
			{_.get(settings, `weekly.cumulativeSales`) && (
				<div className="imageGroup">
					<div className="content mt-24">
						<h3>Cumulative Sales Analysis</h3>
						{props.props.methods.cumulativeSales(props.props.state, props.props.props)}
					</div>
				</div>
			)}
			{_.get(settings, `weekly.tableSalesLotTypeBuilder`) && (
				<div className="imageGroup">
					<div className="content">
						<h2>Sales Breakout</h2>
						<FullTable
							data={props.props.methods.salesBreakoutTable(props.props.state, props.props.props)}
							columns={props.state.salesBreakoutTable}
							name="weekly__salesBreakout"
							title="Weekly Sales Breakout"
						/>
						<h2 style={{ marginBottom: 20 }}>Traffic Breakout</h2>
						<FullTable
							data={props.props.methods.trafficBreakoutTable(props.props.state, props.props.props)}
							columns={props.props.methods.trafficBreakoutColumns(props.props.state, props.props.props)}
							name="weekly__traffic_breakout"
							title="Weekly Traffic Breakout"
						/>
					</div>
				</div>
			)}
			<div className="imageGroup">
				<div className="statBox">
					{_.get(props.props.state, `user.group`) == 1 || !_.get(settings, `weekly.restrictSalesMeter`) ? (
						<div className="statBox__row  statBox__row--double">
							<div className="statBox__box hidden lg:block">
								<h3 className="statBox__title">Sales Variance by Lot Type</h3>
								{props.props.methods.salesVariance(
									props.props.state,
									props.props.props,
									props.props.type
								)}
							</div>
							<div className="statBox__box">
								<h3 className="statBox__title">Traffic by Builder + Lot Type</h3>
								{props.props.methods.trafficBuilderLotType(
									props.props.state,
									props.props.props,
									props.props.type
								)}
							</div>
						</div>
					) : (
						""
					)}
					<div className="statBox__row statBox__row--triple">
						<div className="statBox__box">{lotTypes(props.props.props, props.props.state)}</div>
						<div className="statBox__box">
							<h3 className="statBox__title">Builder Sales</h3>
							{props.props.methods.builderSales(props.props.state, props.props.props)}
						</div>
						<div className="statBox__box">
							<h3 className="statBox__title">Traffic - Number of Visits</h3>
							{props.props.methods.numberVisits(props.props.state, props.props.props)}
						</div>
					</div>
					<div className="statBox__row statBox__row--double">
						<div className="statBox__box">
							<h3 className="statBox__title">Builder and Lot Type Sales</h3>
							{props.props.methods.builderSalesAndLotType(props.props.state, props.props.props)}
						</div>
						<div className="statBox__box">
							<h3 className="statBox__title">Sales by Salespeople</h3>
							{props.props.methods.salesBySalespeople(props.props.state, props.props.props)}
						</div>
					</div>
				</div>
			</div>
			<div className="imageGroup">
				<div className="content">
					{_.get(props.props.state, `user.group`) == 1 &&
					_.get(settings, `enabled.weekly.lotTypeBuilderBar`) ? (
						<div className="statBox__row hideMobile">
							<div className="statBox__box">
								<h3 className="statBox__title">Home Sales - Lot Type &amp; Builder - Net</h3>
								{props.props.methods.lotTypeBuilderBar(
									props.props.state,
									props.props.props,
									props.props.type
								)}
							</div>
						</div>
					) : (
						""
					)}
					{_.get(settings, `enabled.weeklyAverages`) && (
						<>
							<h2>Average Prices</h2>
							<p className="mid">Based on gross sales.</p>
							<ReactTable
								data={props.props.methods.buildAveragesTable(props.props.state, props.props.props)}
								columns={props.state.averageColumns}
								loadingText=""
								defaultPageSize={10}
								filterable
								ref={(r) => {
									props.props.state.sorted.averages = r
								}}
							/>
						</>
					)}
					{!settings.disabled.weeklySpecs && (
						<>
							<h2 style={{ marginBottom: 20 }}>Current Specs</h2>
							<ReactTable
								data={props.props.state.specs}
								columns={props.state.specsColumns}
								loadingText=""
								defaultPageSize={10}
								filterable
								ref={(r) => {
									props.props.state.sorted.specs = r
								}}
							/>
						</>
					)}
					{_.get(settings, `enabled.weeklyAnalytics`) &&
						_.get(props.props.state, `webAnalytics`) &&
						props.props.state.active == "week" && (
							<>
								<h2>Web Analytics</h2>
								<div className="quickStats quickStats--light">
									<ul className="quickStats__list">
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(_.get(props.props.state, `webAnalytics[0].users`)).format(
														"0,0"
													)}
												</div>
												<div className="quickStats__type">Users</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].percentNewUsers`)
													).format("0,0")}
													%
												</div>
												<div className="quickStats__type">Percent New Users</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].sessions`)
													).format("0,0")}
												</div>
												<div className="quickStats__type">Sessions</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].pageviews`)
													).format("0,0")}
												</div>
												<div className="quickStats__type">Pageviews</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].bounceRate`)
													).format("0,0")}
													%
												</div>
												<div className="quickStats__type">Bounce Rate</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].pagesPerSession`)
													).format("0,00.00")}
												</div>
												<div className="quickStats__type">Pages Per Session</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].avgSessionDuration`)
													).format("0,00.00")}
												</div>
												<div className="quickStats__type">Average Session Duration</div>
											</div>
										</li>
										<li className="quickStats__item">
											<div>
												<div className="quickStats__stat">
													{numeral(
														_.get(props.props.state, `webAnalytics[0].sessionsPerUser`)
													).format("0,00.00")}
												</div>
												<div className="quickStats__type">Sessions Per User</div>
											</div>
										</li>
									</ul>
								</div>
							</>
						)}
					<h2 style={{ marginBottom: 20 }}>Sales</h2>
					<FullTable
						data={props.props.methods.buildSalesTable(props.props.state, props.props.props)}
						columns={props.state.columns}
						name="weekly__sales"
						title="Weekly Sales"
					/>
					{settings?.weekly?.showSalesInputTable ? (
						<>
							<h2 style={{ marginBottom: 20 }}>Sales Input</h2>
							<FullTable
								data={props.props.methods.buildSalesTable(props.props.state, props.props.props, true)}
								columns={props.state.columns}
								name="weekly__sales_input"
								title="Weekly Sales Input"
							/>
						</>
					) : null}

					<h2>Cancels</h2>
					<p className="mid">Detailed information is available in the Cancels module.</p>
					<FullTable
						data={props.props.methods.buildCancelsTable(props.props.state, props.props.props)}
						columns={props.state.cancelColumns}
						name="weekly__cancels"
						title="Weekly Cancels"
					/>
				</div>
			</div>
			<div className="imageGroup">
				<div className="content">
					<h2>Closings</h2>
					<p className="mid">Detailed information is available in the Closings module.</p>
					<FullTable
						data={props.props.methods.buildClosingsTable(props.props.state, props.props.props)}
						columns={props.state.closingColumns}
						name="weekly__closings"
						title="Weekly Closings"
					/>
					<h2 style={{ marginBottom: 20 }}>Starts</h2>
					<FullTable
						data={props.props.methods.buildStartsTable(props.props.state, props.props.props)}
						columns={props.state.startColumns}
						name="weekly__starts"
						title="Weekly Starts"
					/>
				</div>
			</div>
			{(props.props.state.active == "ytd" || props.props.state.active == "year") &&
				_.get(settings, `enabled.weekly.ytdAvgSalePrice`) && (
					<div className="imageGroup">
						<div className="content">
							<h2>YTD Average Sale Price</h2>
							<div className="flex justify-end">
								<ImageExport name="YTD Average Sale Price" block={true} twoUp={true} />
								<ExcelOnly
									data={
										props.props.methods.ytdAvgSalePrice(props.props.state, props.props.props).data
									}
									index={0}
									title="YTD Average Sale Price"
								/>
							</div>
							<div className="">
								{
									props.props.methods.ytdAvgSalePrice(
										props.props.state,
										props.props.props,
										props.props.type
									).html
								}
							</div>
						</div>
					</div>
				)}
			{(props.props.state.active == "ytd" || props.props.state.active == "year") &&
				_.get(settings, `enabled.weekly.ytdAnalysis`) && (
					<div className="imageGroup">
						<div className="content">
							<h2>YTD Analysis</h2>
							<div className="flex justify-end">
								<ImageExport name="YTDAnalysis" block={true} />
								<ExcelOnly
									data={props.props.methods.ytdAnalysis(props.props.state, props.props.props).data}
									index={0}
									title="YTD Analysis"
								/>
							</div>
							<div className="">
								{props.props.methods.ytdAnalysis(props.props.state, props.props.props).html}
							</div>
						</div>
					</div>
				)}
		</div>
	)
}

export default DefaultLayout
